import { temAcesso } from '@/shared/auth/temAcesso'
import itensDespesasRotas from '../itensDespesas/ItensDespesasRotas'
import RateiosRotas from '../rateios/RateiosRotas'

const Despesas = () => import('./Despesas.vue') 
const Despesa = () => import('./Despesa.vue') 

export default {
    path: 'despesas',
    name: 'DespesasGerais_Finalizacao_Despesas',
    component: Despesas,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-FINAL-00')) {
            next();
        }
    },
    children: [
        {
            path: ':despesaId',
            name: 'DespesasGerais_Finalizacao_Despesas_Detalhar',
            component: Despesa,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-FINAL-00')) {
                    next()
                }
            },
            children: [itensDespesasRotas, 
                // RateiosRotas
            ]
        },
    ]
}